import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Reveal from '../../../components/shared/Reveal';
import { EditableText, EditableImage, HrefPill } from '../../components';

function SanchetnaProgram({ data, onChange }) {
  const update = (patch) => onChange && onChange({ ...data, ...patch });
  const items = data.items || [];
  const updateItem = (i, patch) => {
    const next = items.map((x, idx) => (idx === i ? { ...x, ...patch } : x));
    update({ items: next });
  };
  return (
    <section className="py-24 bg-olive-light">
      <div className="container-page">
        <Reveal className="grid lg:grid-cols-3 gap-12 items-end">
          <div className="lg:col-span-2">
            <span className="eyebrow"><span className="h-px w-8 bg-olive" />
              <EditableText value={data.eyebrow} onChange={(t) => update({ eyebrow: t })} as="span" />
            </span>
            <h2 className="section-title mt-4">
              <EditableText value={data.heading} onChange={(t) => update({ heading: t })} as="span" />
            </h2>
            <p className="section-lead">
              <EditableText value={data.lead} onChange={(t) => update({ lead: t })} as="span" multiline />
            </p>
          </div>
          <EditableImage
            src={data.image?.src}
            alt={data.image?.alt || 'Sanchetna'}
            onChange={(src, alt) => update({ image: { src, alt } })}
            className="rounded-3xl shadow-soft h-56 w-full object-cover"
          />
        </Reveal>
        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {items.map((s, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div className="card-surface p-7 h-full">
                <EditableText value={s.title} onChange={(t) => updateItem(i, { title: t })} as="h4" className="font-display text-xl text-olive-deep" />
                <EditableText value={s.desc} onChange={(t) => updateItem(i, { desc: t })} as="p" multiline className="mt-3 text-ink/70 text-sm leading-relaxed" />
              </div>
            </Reveal>
          ))}
        </div>
        {data.cta && (
          <div className="text-center mt-12">
            <div className="inline-flex flex-col items-center">
              <Link to={data.cta.href || '#'} className="btn-primary">
                <EditableText value={data.cta.label} onChange={(t) => update({ cta: { ...(data.cta || {}), label: t } })} as="span" />
                <ArrowRight size={16} />
              </Link>
              <HrefPill value={data.cta.href} onChange={(h) => update({ cta: { ...(data.cta || {}), href: h } })} />
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

export default SanchetnaProgram;
